
import React from 'react';
import './Home.css';

import { Container } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';

import {
  FaClipboardCheck,
  FaStore,
  FaFileMedical,
  FaFileSignature,
  FaCheckCircle,
  FaBuilding,
  FaChair,
  FaPhone,
  FaUserCheck,
  FaClock,
  FaHandshake
} from "react-icons/fa";


const services = [
  {
    text: "תכנון העסק",
    icon: <FaClipboardCheck />
  },
  {
    text: "התאמת העסק והדרכה בהתאם לצו רישוי עסקים",
    icon: <FaStore />
  },
  {
    text: "אישור הרשויות המקומיות",
    icon: <FaBuilding />
  },
  {
    text: "אישור משרד הבריאות",
    icon: <FaFileMedical />
  },
  {
    text: "היתר כסאות שולחנות חיצוני וסגירות חורף",
    icon: <FaChair />
  }
];


export const Home = () => (

  <Container>

    <div style={styles.mainContainer}>

      <Fade bottom>

        {/* ================= HERO ================= */}

        <div style={styles.heroSection}>

          <div style={styles.heroBadge}>
            רישוי עסקים • ליווי מקצועי
          </div>

          <h1 style={styles.heroMainTitle}>
            רישוי העסק שלך
            <br />
            <span style={styles.blueText}>
              מתחיל כאן
            </span>
          </h1>

          <p style={styles.heroDescription}>
            מקימים עסק? מחדשים רישיון?
            <br />
            אנחנו כאן כדי לעשות לכם סדר בתהליך.
          </p>


          {/* שלושת המשפטים */}

          <div style={styles.heroTitles}>

            <h2 style={styles.heroTitle}>
              <span>מקימים עסק</span>

              <div style={styles.heroIcon}>
                <FaStore />
              </div>
            </h2>


            <h2 style={styles.heroTitle}>
              <span>מחדשים רישיון</span>

              <div style={styles.heroIcon}>
                <FaFileSignature />
              </div>
            </h2>


            <h2 style={styles.heroTitle}>
              <span>הגעתם למקום הנכון</span>

              <div style={styles.heroIcon}>
                <FaCheckCircle />
              </div>
            </h2>

          </div>


          {/* תמונה ראשית */}

          <div style={styles.heroImageContainer}>

            <img
              src="/1.png"
              alt="רישוי עסקים"
              style={styles.heroImage}
            />

            <div style={styles.imageOverlay}></div>

            <div style={styles.imageText}>
              <h4>
                 אתם מתמקדים בעסק ! 
              </h4>

              <h4>
                אנחנו נטפל בבירוקרטיה !
              </h4>
            </div>

          </div>


          {/* כפתור */}

   <a
  href="tel:0524816141"
  style={{ textDecoration: 'none' }}
>
  <button style={styles.contactButton}>
  
    צרו קשר עכשיו
      <FaPhone />
  </button>
</a>

        </div>


        {/* ================= INTRO ================= */}

        <div style={styles.introSection}>

          <h2 style={styles.sectionTitle}>
            רישוי עסקים – פשוט יותר, מקצועי יותר
          </h2>

   

          <p style={styles.introText}>
השירות שלנו כולל ליווי אישי, מקצועי ומסודר, תוך התאמה לדרישות החוק והרשויות הרלוונטיות
          </p>

        </div>


        {/* ================= SERVICES ================= */}

        <div style={styles.servicesSection}>

          <h2 style={styles.sectionTitle}>
            השירותים שלנו
          </h2>

          <div style={styles.servicesGrid}>

            {
              services.map((item, index) => (

                <div
                  key={index}
                  style={styles.serviceCard}
                >

                  <div style={styles.iconCircle}>
                    {item.icon}
                  </div>

                  <h3 style={styles.serviceText}>
                    {item.text}
                  </h3>

                </div>

              ))
            }

          </div>

        </div>


        {/* ================= WHY US ================= */}

        <div style={styles.whySection}>

          <h2 style={styles.sectionTitle}>
           למה לעבוד איתנו ?
          </h2>


          <div style={styles.whyGrid}>

            <div style={styles.whyCard}>

              <div style={styles.whyIcon}>
                <FaUserCheck />
              </div>

              <h3>ליווי אישי</h3>

              <p>
                ליווי מקצועי ואישי לאורך כל התהליך
              </p>

            </div>


            <div style={styles.whyCard}>

              <div style={styles.whyIcon}>
                <FaClock />
              </div>

              <h3>חיסכון בזמן</h3>

              <p>
                עושים סדר בתהליך וחוסכים לכם זמן ובירוקרטיה
              </p>

            </div>


            <div style={styles.whyCard}>

              <div style={styles.whyIcon}>
                <FaHandshake />
              </div>

              <h3>שירות מקצועי</h3>

              <p>
                התאמה לדרישות הרישוי ולגורמים הרלוונטיים
              </p>

            </div>

          </div>

        </div>


        {/* ================= FINAL CTA ================= */}

        <div style={styles.ctaSection}>

          <h2>
            מוכנים להתחיל?
          </h2>

          <p>
      פותחים עסק חדש? קיבלתם דרישה מהעירייה? אל תתמודדו עם הבירוקרטיה לבד! נעים להכיר, אני שני אדרעי, מומחית לרישוי עסקים וליווי מול הרשויות בישראל. התפקיד שלי הוא להפוך את תהליך הרישוי המורכב לחלק, מהיר וחוקי, תוך הגשת בקשות מדויקות לגורמי האישור השונים. אני כאן כדי להוריד מכם את כאב הראש הבירוקרטי ולהבטיח שהעסק שלכם יעבוד בראש שקט !
          </p>
    <a
  href="tel:0524816141"
  style={{ textDecoration: 'none' }}
>
          <button style={styles.contactButton}>
            <FaPhone />
            דברו איתנו
          </button>
          </a>

        </div>


      </Fade>

    </div>

  </Container>

);

const mobileStyles = `
  @media (max-width: 600px) {
    .image-title {
      font-size: 22px !important;
    }

    .image-subtitle {
      font-size: 17px !important;
    }

    .image-description {
      font-size: 13px !important;
    }
      .h2{
            font-size: 2px !important;

      
      }
  }
`;
const styles = {

  mainContainer: {
    direction: 'rtl',
    textAlign: 'center',
    padding: 'clamp(30px,6vw,70px) 15px',
    fontFamily: 'Segoe UI, Tahoma, Arial, sans-serif',
    minHeight: '100vh',
    width: '100%',
    boxSizing: 'border-box'
  },


  heroSection: {
    marginBottom: '70px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px'
  },


  heroBadge: {
    color: '#00c6ff',
    fontSize: '16px',
    fontWeight: '700',
    background: 'rgba(0,198,255,.1)',
    border: '1px solid rgba(0,198,255,.3)',
    padding: '8px 20px',
    borderRadius: '30px'
  },


  heroMainTitle: {
    fontSize: 'clamp(2.5rem,7vw,5rem)',
    fontWeight: '900',
    color: '#fff',
    lineHeight: '1.15',
    margin: '10px 0',
    textShadow: '0 8px 30px rgba(0,0,0,.4)'
  },


  blueText: {
    color: '#00c6ff'
  },


  heroDescription: {
    color: '#ddd',
    fontSize: 'clamp(1.1rem,3vw,1.5rem)',
    lineHeight: '1.8',
    margin: '0 0 15px'
  },


  heroTitles: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    width: '100%',
    alignItems: 'center'
  },


  heroTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    fontSize: 'clamp(1.3rem,4vw,2.2rem)',
    fontWeight: '800',
    color: '#fff',
    margin: 0,
    lineHeight: '1.3'
  },


  heroIcon: {
    width: '55px',
    height: '55px',
    borderRadius: '50%',
    background:
      'linear-gradient(135deg,#00c6ff,#0072ff)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontSize: '28px',
    boxShadow:
      '0 0 25px rgba(0,140,255,.8)',
    flexShrink: 0
  },


  heroImageContainer: {
    position: 'relative',
    width: '100%',
    maxWidth: '1000px',
    height: 'clamp(280px,45vw,500px)',
    marginTop: '30px',
    borderRadius: '25px',
    overflow: 'hidden',
    boxShadow: '0 20px 60px rgba(0,0,0,.35)'
  },


  heroImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },


  imageOverlay: {
    position: 'absolute',
    inset: 0,
    background:
      'linear-gradient(90deg,rgba(0,30,70,.85),rgba(0,80,160,.2))'
  },


  imageText: {
    position: 'absolute',
    right: '7%',
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#fff',
    textAlign: 'right'
  },

imageTitle: {
  fontSize: 'clamp(1rem, 3.5vw, 2.5rem)',
  fontWeight: '900',
  margin: '0 0 8px',
  textShadow: '0 4px 15px rgba(0,0,0,.5)'
},




contactButton: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',

  background:
    'linear-gradient(135deg,#00c6ff,#0072ff)',

  color: '#fff',
  border: 'none',

  padding: 'clamp(10px, 2.5vw, 14px) clamp(20px, 5vw, 30px)',

  borderRadius: '30px',

  fontSize: 'clamp(14px, 3.5vw, 18px)',

  fontWeight: '700',
  cursor: 'pointer',

  boxShadow:
    '0 8px 25px rgba(0,120,255,.4)',

  margin: '10px auto 0'
},

  introSection: {
    maxWidth: '850px',
    margin: '0 auto 70px'
  },


  sectionTitle: {
    color: '#fff',
    fontSize: 'clamp(1.8rem,5vw,2.8rem)',
    fontWeight: '800',
    marginBottom: '25px'
  },


  introText: {
    color: '#ddd',
    fontSize: 'clamp(1rem,2.5vw,1.25rem)',
    lineHeight: '1.9',
    marginBottom: '10px'
  },


  servicesSection: {
    marginBottom: '80px'
  },


  servicesGrid: {
    width: '100%',
    maxWidth: '820px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '0 5px',
    boxSizing: 'border-box'
  },


  serviceCard: {
    display: 'flex',
    alignItems: 'center',
    padding: '15px',
    borderRadius: '16px',
    background: 'rgba(255,255,255,.08)',
    border: '1px solid rgba(255,255,255,.15)',
    backdropFilter: 'blur(10px)',
    boxShadow: '0 10px 25px rgba(0,0,0,.15)',
    gap: '12px',
    boxSizing: 'border-box'
  },


  iconCircle: {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    background:
      'linear-gradient(135deg,#00c6ff,#0072ff)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontSize: '24px',
    boxShadow:
      '0 0 20px rgba(0,140,255,.6)',
    flexShrink: 0
  },


  serviceText: {
    margin: 0,
    fontSize: 'clamp(1rem,3.5vw,1.25rem)',
    color: '#fff',
    fontWeight: '600',
    textAlign: 'right',
    lineHeight: '1.5'
  },


  whySection: {
    maxWidth: '1000px',
    margin: '0 auto 80px'
  },


  whyGrid: {
    display: 'grid',
    gridTemplateColumns:
      'repeat(auto-fit,minmax(220px,1fr))',
    gap: '20px'
  },


  whyCard: {
    background: 'rgba(255,255,255,.07)',
    border: '1px solid rgba(255,255,255,.12)',
    borderRadius: '20px',
    padding: '30px 20px',
    color: '#fff',
    boxShadow: '0 10px 30px rgba(0,0,0,.15)'
  },


  whyIcon: {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    margin: '0 auto 15px',
    background:
      'linear-gradient(135deg,#00c6ff,#0072ff)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '27px',
    color: '#fff'
  },


  ctaSection: {
    maxWidth: '850px',
    margin: '0 auto 40px',
    padding: '45px 25px',
    borderRadius: '25px',
    background:
      'linear-gradient(135deg,rgba(0,198,255,.15),rgba(0,114,255,.15))',
    border: '1px solid rgba(0,198,255,.25)',
    color: '#fff'
  }

};

